export const adProductIds = (ad) =>
  ad.linkPromoIds?.length ? ad.linkPromoIds : ad.linkPromoId ? [ad.linkPromoId] : [];
